<template>
	<app-page>
		<app-tabs app :tabs="tabs">
			<template v-slot:tab-item="{ tab }">
				<app-tab-item :tab="tab" value="crawlers">
					<app-heading :title="`${market.name} Airbnb Crawlers`">
						<template v-slot:left>
							<app-button v-if="$ravello.can('marketmath.post')"
								class="d-none d-sm-inline-flex"
								color="success"
								small
								outlined
								:to="{ name: 'market-airbnb-crawler', params: { crawler: 'new' } }"
							>Add Crawler</app-button>
						</template>
					</app-heading>
					<app-row>
						<app-cell>
							<app-data-table
								:items="crawlers"
								:headers="headers"
								:total="count"
								:refresh.sync="refresh"
								:initial-state="tableState"
								sort-by="name"
								@update="fetchCrawlers"
							>
								<template v-slot:last_crawl="{ item }">
									<span v-if="item.last_crawl">
										<div>{{ item.last_crawl | datetime(market.timezone)}}</div>
										<i>Found {{item.found == 300 ? `${item.found}+` : item.found}} listings</i>
									</span>
									<span v-else><i>Never</i></span>
								</template>
								<template v-slot:actions="{ item }">
									<app-button
										v-if="$ravello.can('marketmath.post')"
										color="secondary"
										icon="fa-sync"
										table
										@click="onCrawl(item._id)"
									>
										Crawl
									</app-button>
									<app-button
										v-if="$ravello.can('marketmath.put')"
										color="secondary"
										:to="{ name: 'market-airbnb-crawler', params: { crawler: item._id } }"
										icon="fa-pencil-alt"
										table
									>
										Edit
									</app-button>
									<app-button-confirm
										v-if="$ravello.can('marketmath.delete')"
										color="error"
										icon="fa-trash"
										table
										label-confirm="Remove"
										:description="`Are you sure you want to remove crawler`
											+ ` <b>${item.name}</b>?`"
										title="Remove Crawler"
										@click="onDelete(item._id)"
									>
										Remove
									</app-button-confirm>
								</template>
							</app-data-table>
						</app-cell>
					</app-row>
					<app-floating-button
						class="d-inline-flex d-sm-none"
						:to="{ name: 'market-airbnb-crawler', params: { crawler: 'new' } }"
						color="success"
						icon="fa-plus"
					/>
				</app-tab-item>
			</template>
		</app-tabs>
	</app-page>
</template>

<script>
import { filters, search, tableState } from '@/mixins'
import { marketMathAirbnbTabs } from '@/datasources/tabs'

export default {
	mixins: [filters, search, tableState],
	data() {
		return {
			market: {
				name: '',
				timezone: 'UTC',
			},
			crawlers: [],
			count: -1,
			refresh: false,
			tabs: [],
			headers: [{
				text: 'Name',
				value: 'name',
				sortable: true,
			}, {
				text: 'City',
				value: 'market_city.name',
				sortable: false,
			}, {
				text: 'Neighborhood',
				value: 'neighborhood',
				sortable: true,
			}, {
				text: 'Last crawl',
				value: 'last_crawl',
				sortable: true,
			}, {
				text: 'Actions',
				value: 'actions',
				align: 'end',
				sortable: false,
			}],
			defaultTableSort: 'name',
		}
	},
	computed: {
		marketId() {
			return this.$route.params.market
		},
	},
	async mounted() {
		this.market = await this.$ravello.graphql('market', this.marketId)
			.fields(['name', 'timezone'])
			.query()

		this.tabs = marketMathAirbnbTabs(this.marketId)
	},
	methods: {
		async fetchCrawlers(pagination) {
			this.updateTableState(pagination)

			const request = this.$ravello.graphql('airbnbcrawlers')
				.parent(this.$ravello.graphql('market', this.marketId))
				.fields(['_id', 'name', 'neighborhood', 'found', 'last_crawl'])
				.include(this.$ravello.graphql('market_city').field('name'))
				.fromPagination(pagination)

			if (this.count === -1) {
				request.count('count')
			}
			try {
				this.crawlers = await request.query()
				if (this.count === -1) {
					this.count = request.results.count
				}
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
			}
		},

		async onDelete(id) {
			this.$store.dispatch('app/startLoading')
			try {
				await this.$ravello.request()
					.v(2)
					.to('markets')
					.to(this.marketId)
					.to('airbnbcrawlers')
					.to(id)
					.delete()
				this.refresh = true
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
			}
			this.$store.dispatch('app/stopLoading')
		},

		async onCrawl(id) {
			this.$store.dispatch('app/startLoading')
			try {
				await this.$ravello.request()
					.v(2)
					.to('markets')
					.to(this.marketId)
					.to('airbnbcrawlers')
					.to(id)
					.to('crawl')
					.create()
				this.$notifications.pushAlert('success', 'The crawl will start shortly')
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
			}
			this.$store.dispatch('app/stopLoading')
		},
	},
}
</script>
